import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css']
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() totalItems!: number;
  @Input() itemsPerPage!: number;
  @Input() currentPage!: number;
  @Input() pages!: number[];
  @Input() pagedItemsSize!: number;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  visiblePages: number[] = [];
  pageBlockSize: number = 10;

  ngOnInit(): void {
    this.updateVisiblePages();
  }

  ngOnChanges(): void {
    this.updateVisiblePages();
  }

  updateVisiblePages(): void {
    const blockIndex = Math.floor((this.currentPage - 1) / this.pageBlockSize);
    const start = blockIndex * this.pageBlockSize;
    const end = Math.min(start + this.pageBlockSize, this.pages.length);
    this.visiblePages = this.pages.slice(start, end);
  }

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }

  goToPreviousBlock(): void {
    const newPage = Math.max(this.visiblePages[0] - 1, 1);
    this.pageChange.emit(newPage);
  }

  goToNextBlock(): void {
    const newPage = Math.min(this.visiblePages[this.visiblePages.length - 1] + 1, this.pages.length);
    this.pageChange.emit(newPage);
  }
}
